'use client';

import { PropsWithChildren, useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';

import AccountProvider from './AccountProvider';
import PageProvider from './PageProvider';
import StoreProvider from './StoreProvider';

const Providers = (props: PropsWithChildren) => {
  const { children } = props;

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <AccountProvider>
      <PageProvider>
        <StoreProvider>
          {children}

          <Toaster position="top-right" />
        </StoreProvider>
      </PageProvider>
    </AccountProvider>
  );
};

export default Providers;
